document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.tooltip-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const text = wrapper.dataset.tooltip;
    if (!text) return;

    let tooltip = null;

    wrapper.addEventListener('mouseenter', () => {
      if (!tooltip) {
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip';
        tooltip.textContent = text;
        wrapper.appendChild(tooltip);
      }
      tooltip.classList.add('tooltip--visible');
    });

    wrapper.addEventListener('mouseleave', () => {
      if (tooltip) {
        tooltip.classList.remove('tooltip--visible');
      }
    });
  });
});
